<template>
    <v-layout column justify-center align-center py-4>
      <v-card class="reset-wrap pa-4 mb-5">
        <v-alert
          color="error"
          class="err"
          icon="warning"
          value="true"
          v-if="err">{{err}}
        </v-alert>
        <v-form v-model="valid" @submit.native.prevent="submit()">
          <v-flex xs12 class="sub-header">
            <p>Please enter the new password:</p>
          </v-flex>
          <v-text-field
            :label="$lang.actions.enterPassword"
            v-model="password"
            name="password"
            type="password"
            :rules="passwordRules"
            required
          ></v-text-field>
          <v-text-field
            :label="$lang.actions.confirmPassword"
            v-model="repassword"
            name="repassword"
            type="password"
            :rules="passwordRules"
            required
          ></v-text-field>
          <v-flex xs12 class="text-xs-right">
            <v-btn
              color="primary"
              type="submit"
              class="ma-0">{{$lang.actions.resetPassword}}</v-btn>
          </v-flex>
        </v-form>
      </v-card>
    </v-layout>
</template>

<script>
  import auth from '@/auth';

  export default {
    data() {
      return {
        valid: false,
        password: '',
        repassword: '',
        passwordRules: [
          v => !!v || this.$lang.errors.requiredPassword,
          v => (v && v.length >= 6 && v.length <= 35) || this.$lang.errors.passwordConditions,
        ],
        err: '',
      };
    },
    methods: {
      submit() {
        if (!this.valid) return;
        this.err = '';
        if (this.password !== this.repassword) {
          this.err = this.$lang.errors.matchPasswords;
          return;
        }
        this.$webHelper.post('user/resetpassword', {
          resetPasswordToken: this.$route.params.id,
          password: this.password,
        }, this.$router)
          .then((res) => {
            if (!res.success) {
              this.err = this.$lang.errors.failedPassword;
              return null;
            }
            auth.manualLogin(res.body.uuid);
            this.$storage.catalog = null;
            this.$storage.order = null;
            this.$store.dispatch('clearCart');
            this.$storage.company = null;
            this.$store.dispatch('setCompany', null);
            return this.$webHelper.get(`webshopresource/fetchbyexternalid/${this.$route.params.resourceId}`, null, this.$router);
          })
          .then((res) => {
            if (res === null) return;
            if (!res.success) {
              this.err = this.$lang.errors.failedCompanyPassword;
              return;
            }
            const companyData = Object.assign({}, res.body.company, res.body.webShopResource);
            this.$storage.company = companyData;
            this.$store.dispatch('setCompany', companyData);
            this.$router.push({ name: 'webShop', query: { passwordSet: true } });
          });
      },
    },
    created() {
      if (!this.$route.params.resourceId || !this.$route.params.id) {
        this.$router.push({ name: 'webShop' });
        return;
      }
      localStorage.setItem('webShopResourceId', this.$route.params.resourceId);
    },
  };
</script>

<style lang="scss" scoped>
  .reset-wrap {
    min-width: 300px;
    width: 100%;
    max-width: 380px;
  }
</style>



// WEBPACK FOOTER //
// src/components/webshop/Password-reset.vue